module.exports = __webpack_public_path__ + "img/package_bg_3.29e2b0a2.png";